import { Box, styled, Typography } from '@mui/material'

export const StatContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}))

export const Description = styled(Typography)(({ theme }) => ({
  ...theme.typography.button2,
  fontWeight: 400,
  display: 'block',
  maxWidth: '120px',
  color: theme.palette.surface['100'],
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h4,
    fontWeight: 300,
    display: 'inline',
    marginLeft: theme.spacing(1),
    maxWidth: 'none',
  },
}))

export const ArrowContainer = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}))
